import type { NewsItem } from "@/types/content";

export const newsList: NewsItem[] = [
  {
    id: "n-01",
    title: "大桥未久新剧《海边书店》杀青，首支预告公开",
    category: "作品动态",
    date: "2026-10-12",
    summary:
      "历时三个月的拍摄正式结束，剧组公开首支 60 秒预告。新剧以海边小镇的一间旧书店为舞台，预计明年春季与观众见面。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20film%20festival%20red%20carpet%20lights%20at%20night%2C%20warm%20amber%20bokeh%20against%20deep%20navy%20background%2C%20no%20people%2C%20editorial%20photography%2C%20soft%20grain&width=800&height=500&seq=news-01&orientation=landscape",
    views: 18420,
    content: [
      "由高梨知沙执导、大桥未久主演的剧集《海边书店》于本月上旬完成全部拍摄。剧组在社交平台发布了杀青合影与首支预告，时长 60 秒，全程没有一句台词，只有海浪声和翻书声。",
      "据制作方介绍，该剧改编自同名短篇集，全剧共 10 集，每集围绕一本旧书展开。大桥未久在剧中饰演回到故乡接手书店的里见栞，这也是她与高梨知沙继《风起之时》后的第二次合作。",
      "预告片公开后，片尾出现的借书卡特写引发讨论。有观众发现卡片上的日期与导演前作中的时间线完全一致，制作方暂未回应这一猜测，仅表示「剧中有很多留给观众的细节」。",
      "该剧目前已进入后期制作阶段，预计 2027 年春季在电视台与流媒体平台同步播出。",
    ],
  },
  {
    id: "n-02",
    title: "《远山的灯火》入围亚洲电影展主竞赛单元",
    category: "行业动态",
    date: "2026-09-28",
    summary:
      "第 36 届亚洲电影展公布入围名单，《远山的灯火》成为唯一入选主竞赛单元的日本家庭题材作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20clapperboard%20and%20film%20reels%20on%20a%20wooden%20table%20with%20warm%20amber%20lamp%20light%2C%20deep%20navy%20shadows%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=news-02&orientation=landscape",
    views: 12760,
    content: [
      "第 36 届亚洲电影展组委会于本周公布主竞赛单元入围名单，由高梨知沙执导、大桥未久主演的《远山的灯火》名列其中，将与其他 14 部作品共同角逐最佳影片。",
      "影片讲述一所即将关闭的山村小学与一对父女的故事，2023 年上映时曾连续四周位列艺术院线票房前十。评审团在推荐语中提到，影片「用极少的对白完成了一次完整的告别」。",
      "据了解，本届影展将于下月中旬开幕，导演与主演均计划出席首映场。主办方同时宣布，影片的 4K 修复版将在影展期间进行全球首映。",
    ],
  },
  {
    id: "n-03",
    title: "幕后：《潮汐之间》的雨夜长镜头是怎样拍成的",
    category: "幕后花絮",
    date: "2026-09-15",
    summary:
      "一段时长 4 分 12 秒的雨夜长镜头，摄制组拍了整整九个晚上。摄影指导首次公开技术细节。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20movie%20theater%20screen%20glowing%20softly%20in%20a%20dark%20empty%20hall%2C%20warm%20amber%20and%20navy%20tones%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=news-03&orientation=landscape",
    views: 9840,
    content: [
      "《潮汐之间》第四集结尾有一段被观众反复讨论的长镜头：主角从滩涂一路走到灯塔，全程 4 分 12 秒没有剪辑。摄影指导在接受采访时表示，这段戏一共拍了九个晚上。",
      "「最难的不是走位，是雨。」他解释说，剧组使用了两台降雨车和一组手持补光，为了避免灯光在湿地面形成反光，所有光源都加了两层柔光布，「我们要的是能让观众看清脸，又看不清远处的那种亮度」。",
      "主演大桥未久在拍摄前进行了两周的滩涂行走训练，因为退潮后的地面比想象中更难保持稳定。她在采访中笑称，拍完这场戏之后「再也不会在雨天穿错鞋」。",
      "这段长镜头最终保留在成片中，没有使用任何数字合成。制作方表示，幕后特辑将于下月随蓝光版本一并公开。",
    ],
  },
  {
    id: "n-04",
    title: "影评：在《夏日终章》里，夏天如何被温柔地收尾",
    category: "影评",
    date: "2026-08-30",
    summary:
      "上映十年后重看这部作品，它依然提供了关于告别最克制的一种表达方式。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20film%20camera%20on%20tripod%20beside%20a%20seaside%20location%20at%20blue%20hour%2C%20warm%20amber%20light%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=news-04&orientation=landscape",
    views: 7320,
    content: [
      "《夏日终章》并不是一部关于夏天的电影，它更像是一部关于「最后一个夏天」的电影。旧校舍要拆，社团要解散，人要到别的地方去，所有事情都在倒计时里发生。",
      "导演河合直树几乎没有使用配乐。整部影片最响的声音，是风扇、蝉鸣和笔尖划过纸面的声音。这种处理让告别显得不那么戏剧化，也更接近真实经验——大部分告别发生时，周围的世界其实很安静。",
      "大桥未久饰演的松本夏织并不擅长表达。她的表演方式是把情绪放在动作里：反复整理书架、把信折了又打开、在门口停顿两秒。这些细节在十年后重看依然成立。",
      "如果说这部影片有什么让人念念不忘的地方，大概是它没有要求观众哭。它只是把那个夏天完整地留在画面里，然后让镜头慢慢移开。",
    ],
  },
  {
    id: "n-05",
    title: "大桥未久确认出席东京影视内容展，分享角色塑造心得",
    category: "作品动态",
    date: "2026-08-12",
    summary:
      "本届展会将于下月举行，主演将参与两场公开对谈，主题围绕「日常角色的情绪层次」。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20stacked%20screenplays%20and%20a%20coffee%20cup%20on%20a%20desk%20with%20warm%20desk%20lamp%2C%20deep%20navy%20evening%20window%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=news-05&orientation=landscape",
    views: 8650,
    content: [
      "东京影视内容展主办方宣布，大桥未久将作为特别嘉宾出席本届展会，参与两场公开对谈，并出席《远山的灯火》4K 修复版的放映活动。",
      "两场对谈的主题分别为「日常角色的情绪层次」与「从剧本到现场：家庭题材的表演方法」，将由影评人担任主持，现场开放观众提问环节。",
      "主办方表示，本届展会共设 12 个展区，涵盖制作、发行、后期与版权交易，预计吸引超过三万名从业者与观众参与。公开对谈需提前在官网预约，名额有限。",
    ],
  },
  {
    id: "n-06",
    title: "《光的方向》收视稳居同时段前列，法律题材再度回温",
    category: "行业动态",
    date: "2026-07-26",
    summary:
      "播出六周后，该剧平均收视保持在 11% 以上，带动同类型题材的新项目立项。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20empty%20director%20chair%20on%20a%20studio%20set%20with%20warm%20amber%20key%20light%2C%20deep%20navy%20shadows%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=news-06&orientation=landscape",
    views: 10240,
    content: [
      "《光的方向》播出六周，平均收视维持在 11% 以上，成为本季表现最稳定的剧集之一。平台端的完播率同样亮眼，第七集的单集完播率达到 78%。",
      "行业观察者认为，该剧的成功在于把法律题材从「庭审奇观」拉回到具体的人身上。每一集处理的案件都很小，但都指向制度与个体之间的关系。",
      "受此影响，多家制作公司近期公布了法律与社会题材的新项目。有制片人表示，这类作品的制作成本相对可控，但对剧本的要求更高，「观众已经不太接受靠反转撑起来的法庭戏」。",
    ],
  },
  {
    id: "n-07",
    title: "从《无声告白》到《漫长的告白》：家庭叙事的两种温度",
    category: "影评",
    date: "2026-07-05",
    summary:
      "同样关于家庭与沉默，一部选择克制，一部选择倾听。两条路径指向同一个问题：我们如何与家人说话。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20film%20festival%20poster%20wall%20softly%20lit%2C%20warm%20amber%20and%20navy%20palette%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=news-07&orientation=landscape",
    views: 6180,
    content: [
      "《无声告白》上映于 2015 年，《漫长的告白》播出在 2023 年。两部作品相隔八年，却像是一组对照实验：当家庭内部的沟通失效时，故事还能怎么讲。",
      "电影选择了空间。《无声告白》里，母女之间的对话大多发生在走廊、厨房和病房门口，镜头始终保持着一段距离，观众只能从人物的动作判断情绪。",
      "剧集选择了时间。《漫长的告白》用十二集的容量，把三十年的录音带一盘一盘听完。它允许人物反复、犹豫、说错话，也允许观众慢慢理解。",
      "两种方式没有高下之分。它们共同说明了一件事：家庭叙事的力量不来自冲突的强度，而来自创作者愿意花多少时间，去听那些没有说出口的话。",
    ],
  },
  {
    id: "n-08",
    title: "《记忆收藏家》美术设定集公开，复古质感获好评",
    category: "幕后花絮",
    date: "2026-06-18",
    summary:
      "设定集收录了 240 余张场景手稿与道具设计图，其中档案室的木柜全部为实景搭建。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20vintage%20film%20projector%20detail%20closeup%20with%20warm%20amber%20light%20beam%2C%20deep%20navy%20darkness%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=news-08&orientation=landscape",
    views: 5460,
    content: [
      "《记忆收藏家》官方美术设定集于本周发售，全书 208 页，收录了 240 余张场景手稿、道具设计图与拍摄现场照片。",
      "美术指导在书中透露，剧中那间没有招牌的档案室全部为实景搭建，使用了超过 600 个木制抽屉，每个抽屉都贴有手写标签，内容由剧组人员逐一填写。",
      "「我们不希望它看起来像一个奇幻场景，」他在访谈中写道，「它应该像一间真的存在过很久的房间，只是你从来没有注意过它的门牌。」",
      "设定集首印两周内售罄，出版社已宣布加印，并计划推出收录幕后访谈的特别版本。",
    ],
  },
  {
    id: "n-09",
    title: "影视作品档案新增 4K 修复版本条目，含三部早期作品",
    category: "作品动态",
    date: "2026-05-22",
    summary:
      "本站作品档案已完成本轮更新，新增《夏日终章》《无声告白》《雨巷十七号》三部作品的修复版信息。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20a%20quiet%20editing%20suite%20with%20monitors%20glowing%20warm%20amber%20in%20deep%20navy%20room%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=news-09&orientation=landscape",
    views: 4790,
    content: [
      "本站作品档案完成新一轮整理，新增三部早期作品的 4K 修复版条目，分别为《夏日终章》（2016）、《无声告白》（2015）与《雨巷十七号》（2018）。",
      "修复工作由原发行方委托完成，主要处理了胶片划痕、色彩偏移与音轨噪点问题。其中《夏日终章》的修复版重新调色，恢复了当年院线版本中偏暖的色调。",
      "目前档案中标注修复版本的作品共 6 部，相关信息会在作品详情页显示。本站仅提供作品资料与资讯整理，不提供任何播放或下载服务。",
    ],
  },
];